var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-flow-switch"
  }, [_c('div', {
    staticClass: "inner-view event-flow-view",
    class: {
      selected: _vm.eventFlowSelectedValue
    },
    on: {
      "click": function click($event) {
        _vm.eventFlowSelectedValue = true;
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/event-flow/".concat(_vm.eventFlowSelectedValue ? 'active' : 'inactive', "/event-flow-view.svg"))
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t('event-flow.switch.event-flow-view')))])]), _c('div', {
    staticClass: "inner-view table-view",
    class: {
      selected: !_vm.eventFlowSelectedValue
    },
    on: {
      "click": function click($event) {
        _vm.eventFlowSelectedValue = false;
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/event-flow/".concat(!_vm.eventFlowSelectedValue ? 'active' : 'inactive', "/event-flow-table-view.svg"))
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t('event-flow.switch.table-view')))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }